// Module
var code = "<div class=\"tc-sidebar\" :class=\"classes\">\n  <t-button\n    theme=\"lookless\"\n    aria-label=\"close sidebar\"\n    class=\"tc-sidebar-close-button\"\n    @click=\"() => setVisibility(false)\">\n    <tc-icon name=\"arrow\" />\n  </t-button>\n  <tc-menu />\n</div>\n";
// Exports
export default code;